import { useRecoilValue } from 'recoil';
import { integrationAtom } from '../atom';
import React, { useMemo } from 'react';
import { Button } from 'system/atoms';
import { getAtsJobUrl } from '../utils/getAtsJobUrl';

type Props = {
  atsJobId: string | null | undefined;
  label?: string;
};

export const AtsJobLink: React.FC<Props> = ({
  atsJobId,
  label = 'View in ATS'
}) => {
  const integrationCredentials = useRecoilValue(integrationAtom);

  const url = useMemo(() => {
    return getAtsJobUrl({
      integrationCredentials,
      atsJobId
    });
  }, [atsJobId, integrationCredentials]);

  if (!url) {
    return null;
  }

  return (
    <Button
      variant="tertiary"
      onClick={() => {
        window.open(url, '_blank');
      }}
    >
      {label}
    </Button>
  );
};
